import { Checkbox } from '@mui/material'
import { ReactComponent as CheckBox } from 'assets/icons/checkBox.svg'
import CheckBoxActive from 'assets/icons/checkBoxActive'
import { roundingNumber } from 'components/shared/processes'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { lamenessStatuses } from '../processes'
import RangeInputs from './RangeInputs'

const icon = <CheckBox />
const checkedIcon = <CheckBoxActive />

const LamenessContentBlock = props => {
	const { toggleFilter, lameness, availableLamenessValues, handleDayChange } =
		props
	return (
		<>
			<ul>
				{lamenessStatuses.map(point => (
					<li
						onClick={() => toggleFilter('lameness', point.key)}
						key={point.id}
						style={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							padding: '6px 0px',
							cursor: 'pointer',
						}}
					>
						<Checkbox
							icon={icon}
							disableRipple
							checkedIcon={checkedIcon}
							style={{ padding: '0px 8px 0px 0px', margin: '0px' }}
							checked={lameness?.statuses.includes(point.key)}
						/>
						<TypographyPrimary>{point.title}</TypographyPrimary>
					</li>
				))}
			</ul>
			<TypographyPrimary sx={{ margin: '16px 0px' }}>
				Продолжительность, дни
			</TypographyPrimary>
			<RangeInputs
				startValue={lameness?.startOf}
				endValue={lameness?.endOf}
				availableStart={availableLamenessValues?.startOf}
				availableEnd={availableLamenessValues?.endOf}
				formatValue={value => roundingNumber(value, 0)}
				onStartChange={e => handleDayChange(e, 'lameness', 'startOf')}
				onEndChange={e => handleDayChange(e, 'lameness', 'endOf')}
			/>
		</>
	)
}

export default LamenessContentBlock
